import { useAdminLocationV2ControllerCreateLocationWithCustomer } from "service";
import { AdminCreateLocationWithCustomerReqDto } from "service/api/estabrookSchemas";
import { queryKeyFn } from "service/api/estabrookContext";
import { createCustomerLocationsQueryKey } from "service/api/estabrookQueryKeys";
import { toast } from "react-toastify";
import { queryClient } from "@/query-client";

export interface ConvertedTarget {
  customerId?: string;
  addressId?: string;
}

// Converts a lead into a customer + its first location in a single atomic V2
// call (passing `leadId` so the backend links the lead). Reports the created
// ids back so the page can navigate to the new customer.
const useConvertLeadToCustomer = (
  onConverted: (target: ConvertedTarget) => void,
) => {
  const { mutate, isLoading } =
    useAdminLocationV2ControllerCreateLocationWithCustomer({
      onSuccess: (data) => {
        toast.success("Lead converted to customer");

        const customerId = data?.data?.customer?.id;
        const addressId = data?.data?.id;

        // The lead now shows as converted in the list; refresh it.
        queryClient.invalidateQueries(
          queryKeyFn({
            path: "/api/v1/admin/leads",
            operationId: "adminLeadControllerGetAll",
            variables: {},
          }),
        );
        if (customerId) {
          queryClient.invalidateQueries(
            createCustomerLocationsQueryKey(customerId),
          );
        }

        onConverted({ customerId, addressId });
      },
    });

  const convertLead = (body: AdminCreateLocationWithCustomerReqDto) =>
    mutate({ body });

  return { convertLead, isConverting: isLoading };
};

export default useConvertLeadToCustomer;
